import { Map } from 'immutable';
import config, {
  getCurrentLanguage
} from '../../containers/LanguageSwitcher/config';
import defaultLanguageMessages from '../../languageProvider/locales/en_US';
import actions from './actions';

const initState = new Map({
  isActivated: false,
  loading: false,
  language: getCurrentLanguage(config.defaultLanguage || 'english'),
  languageMessages: defaultLanguageMessages,
});

export default function languageSwitcherReducer(state = initState, action) {
  const currentState = state.toJS();  
  switch (action.type) {
    case actions.ACTIVATE_LANG_MODAL:
      return new Map({
        ...currentState,
        isActivated: !currentState.isActivated,
      });
    case actions.CHANGE_LANGUAGE_REQUEST:
      return new Map({
        ...currentState,
        loading: true,
      });
    case actions.CHANGE_LANGUAGE_SUCCESS:
      return new Map({
        ...currentState,
        languageMessages: action.languageMessages,
        language: action.language,
        loading: false,
      });
    case actions.CHANGE_LANGUAGE_ERROR:
      return new Map({
        ...currentState,
        loading: false,
      });
    default:
      return state;
  }
}
